import axios from 'axios'

import MultipartUploader from './multipart-uploader'

class MultipartVideoUploader extends MultipartUploader {
  constructor (filename, config = {}) {
    super(filename, config)

    this._previewPart = null

    this.uploadedPreviewSize = 0
  }

  /**
   * @returns {number}
   */
  get uploadedSize () {
    return super.uploadedSize + this.uploadedPreviewSize
  }

  /**
   * @returns {number}
   */
  get totalSize () {
    return super.totalSize + (this.previewPart?.size || 0)
  }

  /**
   * the first <=5m size part as preview part, for getting the preview image value
   * @returns {Blob}
   */
  get previewPart () {
    if (!this._previewPart) {
      const blob = this.uploadParts[0].data
      const start = super.DEFAULT_FILE_CHUNK_SIZE - blob.size

      this._previewPart = blob
      if (start < 0) {
        this._previewPart = blob.slice(start)
      }
    }

    return this._previewPart
  }

  /**
   * @param {string} url
   * @param {FormData} form
   * @returns {Promise<undefined|*>}
   */
  async uploadPreview (url, form) {
    try {
      const res = await axios.post(url, form)

      this.uploadedPreviewSize = this._previewPart.size
      this.dispatchProgressEvent()

      return res.data.preview_value
    } catch (e) {
      return undefined
    }
  }

  /**
   * @returns {Promise<*|undefined>}
   */
  async uploadVideoPreview () {
    const url = Spark.router('api.upload.preview')

    const form = new FormData()
    form.append('video', this.previewPart, this.filename)
    form.append('disk', this.disk)

    return this.uploadPreview(url, form)
  }

  /**
   * @param {string} videoId
   * @returns {Promise<*|undefined>}
   */
  async uploadVideoReplyPreivew (videoId) {
    const url = Spark.router('api.upload.video_reply_preview')

    const form = new FormData()
    form.append('video', this.previewPart, this.filename)
    form.append('disk', this.disk)
    form.append('video_id', videoId)

    return this.uploadPreview(url, form)
  }
}

export default MultipartVideoUploader
